var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTableBooking(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F2F2F2;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:none;stroke:#006DF0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st3{fill:#006DF0;}\n\t.st4{fill:none;stroke:#37CE93;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st5{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;stroke-dasharray:27,4;}\n\t.st6{fill:none;stroke:#37CE93;stroke-width:3;stroke-miterlimit:10;}\n\t.st7{fill:none;stroke:#006DF0;stroke-width:3;stroke-miterlimit:10;}\n\t.st8{fill:#37CE93;}\n\t.st9{fill:none;stroke:#37CE93;stroke-width:3;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_3"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 50,
    cy: 92.75,
    rx: 49,
    ry: 5.25
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_5"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_6"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_7"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.55,
    y: 81.22,
    className: "st1",
    width: 4.49,
    height: 9.81
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.55,
    y: 81.22,
    className: "st1",
    width: 4.49,
    height: 9.81
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M40.37,11.98v15.01c0,1.61,1.3,2.92,2.92,2.92h13.87c1.61,0,2.92-1.31,2.92-2.92V11.98"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 50.07,
    y1: 11.98,
    x2: 50.07,
    y2: 42.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58.5,48.29c0-2.24-1.48-4.06-3.3-4.06h-9.82c-1.82,0-3.3,1.82-3.3,4.06H58.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M73.76,37.34c0,1.76-1.42,3.18-3.18,3.18c-1.76,0-3.18-1.42-3.18-3.18V31h6.36V37.34z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 70.59,
    y1: 48.29,
    x2: 70.59,
    y2: 40.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M31.85,37.34c0,1.76-1.42,3.18-3.18,3.18c-1.76,0-3.18-1.42-3.18-3.18V31h6.36V37.34z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 28.67,
    y1: 48.29,
    x2: 28.67,
    y2: 40.52
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M38.51,8.37c-0.25,0.37-0.39,0.81-0.39,1.29c0,1.28,1.04,2.31,2.31,2.31c1.28,0,2.31-1.04,2.31-2.31 c0-0.48-0.15-0.93-0.4-1.3l-1.92-2.68L38.51,8.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M48.15,8.37c-0.25,0.37-0.4,0.81-0.4,1.29c0,1.28,1.04,2.31,2.32,2.31c1.28,0,2.31-1.04,2.31-2.31 c0-0.48-0.15-0.93-0.4-1.3l-1.91-2.68L48.15,8.37z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M58.15,8.37c-0.25,0.37-0.39,0.81-0.39,1.29c0,1.28,1.03,2.31,2.31,2.31c1.28,0,2.31-1.04,2.31-2.31 c0-0.48-0.15-0.93-0.4-1.3l-1.92-2.68L58.15,8.37z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "7.25,36.49 11.75,65.21 8.16,91.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "19.21,62.02 11.25,62.02 11.75,65.21 11.25,69.25 19.21,69.25  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "92.75,36.49 88.25,65.21 91.84,91.04  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "80.79,62.02 88.75,62.02 88.25,65.21 88.75,69.25 80.79,69.25  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M19.94,79.96c0,0,8.82-11.42,18.66,0c0,0,2.39,3.35,5.36,0c0,0,5.54-11.19,14.19,0.12c0,0,2.77,2.77,5.54,0 c0,0,8.42-11.19,16.38,0V48.14H19.94V79.96z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M22.54,77.78v13.25h4.5V75.18C27.04,75.18,24.2,76.22,22.54,77.78z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M77.6,77.78v13.25h-4.98V75.18C72.61,75.18,75.12,75.18,77.6,77.78z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_8"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableBooking);
export default __webpack_public_path__ + "static/media/Table_Booking.91536f224fd22fc375bdd60c09d85d65.svg";
export { ForwardRef as ReactComponent };